import { useEffect, useRef, useState } from "react";

declare global {
  interface Window {
    Youreko?: {
      EnergySavingsModal?: {
        show: () => void;
      };
    };
  }
}

const openYourekoModal = () => {
  window.Youreko?.EnergySavingsModal?.show?.();
};

export function useYourekoModal(refetch: () => void) {
  const [shouldLoadScript, setShouldLoadScript] = useState(false);
  const proxyRef = useRef<HTMLDivElement>(null);
  const refetchRef = useRef(refetch);

  useEffect(() => {
    refetchRef.current = refetch;
  }, [refetch]);

  useEffect(() => {
    const node = proxyRef.current;
    if (!node) return;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-youreko-clicked" &&
          mutation.target instanceof Element &&
          !mutation.target.hasAttribute("data-youreko-clicked")
        ) {
          refetchRef.current();
        }
      }
    });

    observer.observe(node, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["data-youreko-clicked"],
      attributeOldValue: true,
    });

    return () => observer.disconnect();
  }, []);

  const handleOpenModal = () => {
    if (!shouldLoadScript) {
      setShouldLoadScript(true);
    } else {
      openYourekoModal();
    }
  };

  return {
    proxyRef,
    shouldLoadScript,
    handleOpenModal,
    handleScriptLoad: openYourekoModal,
  };
}
